import makeStyles from '@material-ui/styles/makeStyles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SearchIconSVG } from '../../../../assets/images/icon-search.svg';

export interface ISearchInput {
    onSearchChange: (searchValue: string) => void;
    classes?: any;
}

const useStyles = makeStyles({
    SearchInput: {
        border: '0.5px solid #AAB6D3',
        position: 'relative',
        borderRadius: '8px',
        height: '2.5rem',
        marginRight: '1rem',
        '& input': {
            border: 'none',
            width: '100%',
            height: '100%',
            padding: '0 0 0 2.3rem',
            borderRadius: '8px',
            backgroundColor: 'transparent',
            '&:focus': {
                outlineColor: '#FFDD02',
                outlineWidth: '0.5px',
            },
        },
        '& >svg': {
            position: 'absolute',
            left: '0.9375rem',
            top: '0',
            bottom: '0',
            margin: 'auto',
        },
    },
});

function SearchInput(props: ISearchInput) {
    const { t } = useTranslation();
    const classes = useStyles();
    const classesProps = props.classes;
    return (
        <div className={classesProps ? classesProps.SearchInput : classes.SearchInput}>
            <SearchIconSVG width="1rem" height="1.1rem" />
            <input placeholder={t('misc.searchItems')} onChange={(e) => props.onSearchChange(e.target.value)} />
        </div>
    );
}

export default SearchInput;
